import React from 'react';
import { IconUpload, IconClipboard, IconFileText, IconChartLine } from '../../components/dashboardIcons';
import ElementIcon from '../../components/ElementIcon';
import { themeVars } from '../../config/theme';

const fmt = (n) => (Math.round(n * 100) / 100).toFixed(2);

// 'overview' shows the scorecard breakdown, so "View scorecard" opens the overview.
export const ACTIONS = [
  { view: 'upload',    label: 'Upload data sheet', Icon: IconUpload },
  { view: 'overview',  label: 'View scorecard',    Icon: IconClipboard },
  { view: 'documents', label: 'Upload documents',  Icon: IconFileText },
  { view: 'report',    label: 'View report',       Icon: IconChartLine },
];

// score = { points, maxPoints, subMinimumMet } | null
const ElementCard = ({ group, score, onOpen }) => {
  const pct = score && score.maxPoints > 0
    ? Math.min(Math.round((score.points / score.maxPoints) * 100), 100)
    : null;

  const needsAction = !score || score.subMinimumMet === false;
  const complete = pct === 100;

  let statusCls = 'ok';
  let statusLabel = 'On track';
  if (!score) { statusCls = 'act'; statusLabel = 'No data yet'; }
  else if (score.subMinimumMet === false) { statusCls = 'act'; statusLabel = 'Action needed'; }
  else if (complete) { statusLabel = 'Complete'; }

  // Every card leads with "View scorecard"; the other actions are the icon buttons.
  const primary = ACTIONS.find((a) => a.view === 'overview');
  const rest = ACTIONS.filter((a) => a.view !== 'overview');

  const open = (view) => (e) => { e.stopPropagation(); onOpen(view); };

  return (
    <div
      role="button"
      tabIndex={0}
      className={`cd-card themed ${needsAction ? 'is-attn' : ''}`}
      style={themeVars(group.key)}
      onClick={() => onOpen('overview')}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onOpen('overview'); } }}
    >
      <div className="cd-card-top">
        <ElementIcon element={group.key} />
        <div className="cd-card-head">
          <div className="nm">{group.label}</div>
          <div className="pts">
            {score ? <><b>{fmt(score.points)}</b> / {score.maxPoints} points</> : 'Not calculated'}
          </div>
        </div>
        <div className="cd-card-pct">{pct != null ? `${pct}%` : '—'}</div>
      </div>

      <div className="cd-bar"><i style={{ width: `${pct ?? 0}%` }} /></div>
      <span className={`cd-status ${statusCls}`}>{statusLabel}</span>

      <div className="cd-card-acts">
        <button type="button" className="cd-btn cd-btn--primary" onClick={open(primary.view)}>
          <primary.Icon /> {primary.label}
        </button>
        {rest.map(({ view, label, Icon }) => (
          <button
            key={view}
            type="button"
            className="cd-iconbtn"
            title={label}
            aria-label={label}
            onClick={open(view)}
          >
            <Icon />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ElementCard;
